<script>
import API from "@/data/API.js";
import { apiModel } from "@/models";
import ErrorHandler from "@/components/ErrorHandler.vue";
import LookupForm from "@/components/Lookup/Form.vue";
import {
    documentStatusCodes,
    statuses
} from "@/assets/JS/Assets.js";
import {
    VALIDATION,
    inputErrorTypes
} from "@/assets/JS/Validation.js";

export default {
    name: "MainView",
    components: {
        ErrorHandler,
        LookupForm
    },
    data: () => ({
        ...apiModel,
        submitted: false,
        loader: {
            show: false,
            content: "",
            overlayStatic: false,
            fadeContent: false
        },
        status: {}
    }),
    methods: {
        Submit: async function(licenseNumber) {
            let status = {};
            this.StartLoader();
            if (VALIDATION.Numeric(licenseNumber)) {
                licenseNumber = Number(licenseNumber);
                const certificate = await API.ReadCertificate(this, licenseNumber);
                const certificateExists = Object.keys(certificate).length > 0 && certificate.licenseNumber !== 0;
                if (certificateExists) {
                    this.UpdateStatuses(certificate);
                    const {
                        issued,
                        received,
                        registered,
                        rejected
                    } = statuses;
                    switch(true) {

                        // Issued
                        case issued.state:
                            status = {
                                label: "Issued",
                                ...issued,
                                message: "You have obtained your marriage license and once you participate in a qualified ceremony, the marriage license must be completed and returned for recording.",
                                icon: "IconIssued.png"
                            };
                            break;

                        // Received
                        case received.state:
                            status = {
                                label: "Received and in Process",
                                ...received,
                                message: "We have received your license back and it's being processed.",
                                icon: "IconReceived.png"
                            };
                            break;

                        // Recorded
                        case registered.state:
                            status = {
                                label: "Recorded",
                                ...registered,
                                message: "Your marriage license has been recorded. If you ordered copies, it will be mailed out to you, or you may now come in and request copies.",
                                icon: "IconRegistered.png"
                            };
                            break;

                        // Cancelled
                        case rejected.state:
                            status = {
                                label: "Cancelled",
                                ...rejected,
                                message: "If you have any questions, please contact the marriage license section at 1-800-201-8999 Option 1 to discuss your marriage license.",
                                icon: "IconRejected.png"
                            };
                            break;

                    }
                    status.issuedDate = issued.date;
                } else {
                    status = {
                        label: inputErrorTypes.notFound,
                        icon: "IconNotFound.png",
                        message: "Certificate not found"
                    };
                }
            } else {
                status = {
                    label: inputErrorTypes.invalid,
                    message: "The license number must contain only numbers.",
                    error: true
                };
            }
            this.status = status;
            this.StopLoader();
        },
        UpdateStatuses: function(certificate) {
            const {
                licenseIssuedTS,
                licenseReceivedTS,
                registrationTS,
                documentStatusCode
            } = certificate;
            const archived = documentStatusCode === documentStatusCodes.archived.code;
            statuses.issued = {
                state: licenseIssuedTS !== null,
                date: licenseIssuedTS
            };
            statuses.received = {
                state: licenseReceivedTS !== null && this.ValidDocumentStatusCode() && !archived,
                date: licenseReceivedTS
            }
            statuses.registered = {
                state: registrationTS !== null && archived,
                date: registrationTS
            };
            statuses.rejected = {
                state: documentStatusCode === documentStatusCodes.rejected.code
            };

            // Force only one status to be true
            const statusTypes = [];
            let selectedStatusIndex, statusIndex;
            selectedStatusIndex = 0;
            statusIndex = -1;
            for (const status in statuses) {
                statusTypes.push(status);
                statusIndex++;
                if (statuses[status].state) {
                    selectedStatusIndex = statusIndex;
                }
                statuses[status].state = false;
            }
            const selectedStatus = statusTypes[selectedStatusIndex];
            statuses[selectedStatus].state = true;

        },
        ValidDocumentStatusCode: function(certificateDocumentStatusCode) {
            let valid = true;
            for (const documentStatusCode in documentStatusCodes) {
                if (documentStatusCodes[documentStatusCode].code === certificateDocumentStatusCode) {
                    valid = false;
                }
            }
            return valid;
        },
        StartLoader: function() {
            this.loader = {
                show: true,
                content: "#form-lookup",
                overlayStatic: true,
                fadeContent: true
            };
        },
        StopLoader: function() { this.loader.show = false; }
    }
};
</script>

<template>
    <div id="lookup" class="main-content">
        <div id="introduction">
            <p>Check the status of your marriage license certificate.</p>
        </div>
        <LookupForm
            :submitted="submitted"
            :status="status"
            :loader="loader"
            @submit="Submit($event)"
        />
    </div>
</template>